import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataPreparation, DataPreparationResponse } from '../models/data-preparation.model';
import { MasterService } from '../../../base-classes/master-service';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DataPreparationService extends MasterService<DataPreparation> {

    constructor(http: HttpClient) {
        super(http, `${environment.apiUrl}/test-data`);
        this.http = http;
    }

    uploadFile(clientId: string, packageId: string, file: File): Observable<DataPreparation> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('clientId', clientId);
        formData.append('packageId', packageId);

        return this.http.post<DataPreparation>(`${environment.apiUrl}/test-data`, formData);
    }

    replaceFile(id: string, clientId: string, packageId: string, file: File): Observable<DataPreparation> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('clientId', clientId);
        formData.append('packageId', packageId);

        return this.http.put<DataPreparation>(`${environment.apiUrl}/test-data/${id}`, formData);
    }

    getAllTestData(): Observable<DataPreparation[]> {
        return this.http.get<DataPreparation[]>(`${environment.apiUrl}/test-data`);
    }

    getTestDataById(id: string): Observable<DataPreparation> {
        return this.http.get<DataPreparation>(`${environment.apiUrl}/test-data/${id}`);
    }

    getByClientPackageId(clientPackageId: string): Observable<DataPreparation[]> {
        return this.http.get<DataPreparation[]>(`${environment.apiUrl}/test-data/by-client-package/${clientPackageId}`);
    }

    updateTestData(id: string, data: Partial<DataPreparation>): Observable<DataPreparation> {
        return this.http.put<DataPreparation>(`${environment.apiUrl}/test-data/${id}`, data);
    }

    deleteTestData(id: string): Observable<{ message: string }> {
        return this.http.delete<{ message: string }>(`${environment.apiUrl}/test-data/${id}`);
    }

    getPackagesByClient(clientId: string): Observable<any[]> {
        return this.http.get<any[]>(`${environment.apiUrl}/client-package-mapping/client/${clientId}`);
    }

    getClients(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.apiUrl}/clients/user-clients`);
    }

    downloadFile(id: string): Observable<Blob> {
        return this.http.get(`${environment.apiUrl}/test-data/${id}/download`, { 
            responseType: 'blob'
        });
    }
}
